import moment, { Moment } from 'moment';
export type ITimelineItem = {
  id: string;
  value: Moment;
  disabled?: boolean;
}

export const setTime = (hour: number, minute?: number, second?: number, ddd?: string) => moment().set({ hour, minute: minute || 0, second: second || 0 });
export const setTimeByDdd = (date: Moment, hour: number, minute?: number) => moment(date).set({ hour, minute: minute || 0 });

const getTimeLines = (startTime: Moment, endTime: Moment, distance?: number) => {
  const _distance = distance || 30;
  const times: ITimelineItem[] = [];
  let time = startTime;
  const now = moment();

  while (time <= endTime) {
    if (time.isBefore(now)) {
      time = time.clone().add(_distance, 'minute');
      continue;
    }
    times.push({
      id: time.format('hh:mm A'),
      value: time,
      disabled: time.isBefore(now),
    });
    time = time.clone().add(_distance, 'minute');
  }
  return times;
};

export const getTimeLinesByDdd = (startTime: Moment, endTime: Moment, distance?: number) => {
  const _distance = distance || 30;
  const times: ITimelineItem[] = [];
  let time = startTime;
  while (time <= endTime) {
    times.push({
      id: time.format('hh:mm A'),
      value: time,
    });
    time = time.clone().add(_distance, 'minute');
  }
  return times;
};

export default getTimeLines;
